<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte';
    import { getSelectSize } from 'header/utils/getSelectSize';
    import type {
        InteractiveTitleSelectDefinition,
        InteractiveTitleSelectNumberDefinition,
    } from '../../types';

    interface Props {
        field: InteractiveTitleSelectDefinition | InteractiveTitleSelectNumberDefinition;
    }

    let { field }: Props = $props();

    type Options =
        | InteractiveTitleSelectDefinition['options'][number]
        | InteractiveTitleSelectNumberDefinition['options'][number];

    let select = $state<HTMLSelectElement | null>(null);
    let options = $derived(field.options as Options[]);
    let selectedIndex = $derived(field.options.findIndex(option => option.key === field.value));
    let selectedLabel = $derived(selectedIndex !== -1 ? field.options[selectedIndex].label : '');

    onMount(() => {
        changeSelectSize(selectedLabel);
    });

    const changeSelectSize = (selectedLabel: string) => {
        if (!select) return;
        select.style.width = getSelectSize(selectedLabel, select);
    };

    const dispatch = createEventDispatcher();
    const onChange = (e: { currentTarget: HTMLSelectElement }) => {
        const optionIndex = parseInt(e.currentTarget.value, 10);

        dispatch('change', {
            ...field,
            value: field.options[optionIndex]?.key || field.value,
        });
    };
</script>

<select bind:this={select} value={selectedIndex} oninput={onChange}>
    {#each options as { label }, index}
        <option value={index}>{label}</option>
    {/each}
</select>

<style lang="scss" scoped>
</style>
